// extracted by mini-css-extract-plugin
export default {"wrap":"ModalAlert_wrap__1PBty","success":"ModalAlert_success__iFe9G","error":"ModalAlert_error__D5LW-"};